'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _phaserCe = require('phaser-ce');

var _phaserCe2 = _interopRequireDefault(_phaserCe);

var _Body2 = require('./Body');

var _Body3 = _interopRequireDefault(_Body2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Body) {
  _inherits(_class, _Body);

  function _class(_ref) {
    var game = _ref.game,
        x = _ref.x,
        y = _ref.y,
        asset = _ref.asset,
        id = _ref.id;

    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, { game: game, x: x, y: y, asset: asset, id: id }));

    _this.maxSpeed = 300;
    _this.fireRate = 200;
    console.log('PlayerId: ' + id);

    game.camera.follow(_this);

    /**
     * Capture the cursor and the keyboard keys
     */
    _this.cursor = game.input.keyboard.createCursorKeys();
    _this.spaceButton = game.input.keyboard.addKey(_phaserCe2.default.Keyboard.SPACEBAR);
    _this.wasd = {
      up: game.input.keyboard.addKey(_phaserCe2.default.Keyboard.W),
      left: game.input.keyboard.addKey(_phaserCe2.default.Keyboard.A),
      right: game.input.keyboard.addKey(_phaserCe2.default.Keyboard.D),
      down: game.input.keyboard.addKey(_phaserCe2.default.Keyboard.S)
    };

    _this.shootingSound = game.add.audio('shoot');
    //  Creates 30 bullets, using the 'bullet' graphic
    _this.weapon = game.add.weapon(30, 'bullet');
    //  The bullet will be automatically killed when it leaves the world bounds
    _this.weapon.bulletKillType = _phaserCe2.default.Weapon.KILL_WORLD_BOUNDS;
    //  The speed at which the bullet is fired
    _this.weapon.bulletSpeed = 600;
    //  Speed-up the rate of fire, allowing them to shoot 1 bullet every 60ms
    _this.weapon.fireRate = _this.fireRate;
    _this.weapon.trackSprite(_this.torso, 0, 0, false);
    //  Fix the position of the bullets to create from the gun
    _this.weapon.bullets.setAll('anchor.x', -6);
    _this.weapon.bullets.setAll('anchor.y', 0);
    _this.weapon.onFire.add(_this.newShot, _this);
    return _this;
  }

  _createClass(_class, [{
    key: 'update',
    value: function update() {
      _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'update', this).call(this);
      this.body.velocity.x = 0;
      this.body.velocity.y = 0;
      this.legs.body.angularVelocity = 0;

      if (this.cursor.left.isDown || this.wasd.left.isDown) this.legs.body.angularVelocity = -this.maxSpeed;else if (this.cursor.right.isDown || this.wasd.right.isDown) this.legs.body.angularVelocity = this.maxSpeed;

      var direction = null;
      if (this.cursor.up.isDown || this.wasd.up.isDown) direction = 1;
      if (this.cursor.down.isDown || this.wasd.down.isDown) direction = -1;

      if (direction) {
        var angle = this.legs.angle - 90;
        this.game.physics.arcade.velocityFromAngle(angle, direction * this.maxSpeed, this.body.velocity);

        this.torso.animations.play('walk');
        this.legs.animations.play('walk');
      } else {
        this.torso.animations.stop();
        this.legs.animations.stop();
        this.torso.frame = 2;
        this.legs.frame = 0;
      }

      if (this.spaceButton.isDown) {
        this.torso.animations.stop();
        this.torso.frame = 0;
        this.weapon.fireAngle = this.torso.angle - 90;
        this.weapon.fire();
      }
    }
  }, {
    key: 'newShot',
    value: function newShot() {
      this.shootingSound.play();
    }
  }]);

  return _class;
}(_Body3.default);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/sprites/Player.js
// module id = 385
// module chunks = 0